import React from 'react';

import { Divider, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as ChevronLeftBlue } from '../../../../assets/icons/chevron_left_blue.svg';

type Props = {
  route: any;
  title: string;
};

const HeaderBackButton: React.FC<Props> = ({ route, title }) => {
  const navigate = useNavigate();
  return (
    <>
      <Divider
        orientation='vertical'
        flexItem
        sx={{
          marginLeft: '30px',
          marginRight: '30px',
          display: { xs: 'none', md: 'block' },
        }}
      />
      <Button
        color='darkBlue'
        variant='text'
        onClick={() => navigate(route)}
        sx={{
          display: { xs: 'none', md: 'flex' },
        }}
      >
        <ChevronLeftBlue />
        <Typography>{title}</Typography>
      </Button>
    </>
  );
};

export default HeaderBackButton;
